/** Filter table rows by login visibility (active vs disabled accounts). */

export function rowLogin(row) {
  const lg = Number(row?.login);
  return Number.isFinite(lg) && lg > 0 ? lg : null;
}

export function filterLoginRows(rows, disabledSet, { showDisabledOnly = false } = {}) {
  if (!disabledSet?.size && !showDisabledOnly) return rows;
  return (rows || []).filter((row) => {
    const lg = rowLogin(row);
    if (!lg) return !showDisabledOnly;
    const isDisabled = disabledSet.has(lg);
    return showDisabledOnly ? isDisabled : !isDisabled;
  });
}

export function filterSymbolRows(rows, disabledSet, { showDisabledOnly = false } = {}) {
  if (!disabledSet?.size && !showDisabledOnly) return rows;
  return (rows || []).filter((row) => {
    const lg = rowLogin(row);
    if (!lg) return !showDisabledOnly;
    const isDisabled = disabledSet.has(lg);
    return showDisabledOnly ? isDisabled : !isDisabled;
  });
}

export function buildLoginNameMap(...rowGroups) {
  const map = new Map();
  for (const rows of rowGroups) {
    for (const row of rows || []) {
      const lg = rowLogin(row);
      if (!lg || map.has(lg)) continue;
      const name = String(row.name || '').trim();
      if (name) map.set(lg, name);
    }
  }
  return map;
}

export function buildDisabledAccountRows(disabledLogins, nameByLogin, profitByLogin) {
  return (disabledLogins || []).map((login) => ({
    login,
    name: nameByLogin.get(login) || '—',
    profit: profitByLogin.get(login),
  }));
}
